module.exports = __webpack_public_path__ + "img/edit2.94d45a4d.png";